import { IconButton } from "@mui/material"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { EditOutlined, MoreVertOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React, { useRef, useState } from "react"

import type { CompanyCertification } from "@/graphql/codegen/graphql"
import type { TransformedCertificationTableItem } from "@/screens/Companies/edit/components/certification/types"

const CertificationRowActions: FC<{
  transformedCertification: TransformedCertificationTableItem
  onEdit: (certification: CompanyCertification) => void
}> = ({ onEdit, transformedCertification }) => {
  const { current, upcoming } = transformedCertification

  const [menuOpen, setMenuOpen] = useState<boolean>(false)
  const anchorElRef = useRef<HTMLButtonElement>(null)

  if (!current && !upcoming) {
    return null
  }

  return (
    <>
      <IconButton onClick={() => setMenuOpen(!menuOpen)} ref={anchorElRef}>
        <MoreVertOutlined />
      </IconButton>

      <Menu
        anchorEl={anchorElRef.current}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {current && (
          <MenuItem onClick={() => onEdit(current)}>
            <ListItemIcon>
              <EditOutlined className='text-gray-600' />
            </ListItemIcon>
            <ListItemText primary='Update Current Certification' className='text-gray-800' />
          </MenuItem>
        )}
        {upcoming && (
          <MenuItem onClick={() => onEdit(upcoming)}>
            <ListItemIcon>
              <EditOutlined className='text-gray-600' />
            </ListItemIcon>
            <ListItemText primary='Update Upcoming Certification' className='text-gray-800' />
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export default CertificationRowActions
